export default __webpack_public_path__ + "static/Best-Countries-for-Shopaholics-BuenosAires-Argentina-900308779036662dce0f3ea2cd25cc3a.jpg";